import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from "react";
import PassengersFooter from "../components/footer/index.js";
import usePassengers from "./usePassengers.js";
const usePassengersMobile = (props)=>{
    const { value , onChange , literals  } = props;
    const { passengersLabel =''  } = literals ?? {};
    const [isOpen, setOpen] = useState(false);
    const [tempValue, setTempValue] = useState(props.value);
    useEffect(()=>{
        if (!isOpen) {
            setTempValue(value);
        }
    }, [
        isOpen,
        value
    ]);
    const { value: finalValue , inputProps , disableIncrement , handleOnChange , handleOnSelectChange  } = usePassengers({
        ...props,
        value: tempValue,
        onChange: setTempValue
    });
    const onAccept = useCallback((close)=>()=>{
            if (tempValue && onChange) onChange(tempValue);
            close();
        }, [
        onChange,
        tempValue
    ]);
    const renderFooter = useCallback(({ close  })=>/*#__PURE__*/ _jsx(PassengersFooter, {
            onClick: onAccept(close),
            literals: literals
        }), [
        literals,
        onAccept
    ]);
    const basePanel = useMemo(()=>({
            onChange: setOpen,
            header: passengersLabel,
            footer: renderFooter
        }), [
        passengersLabel,
        renderFooter
    ]);
    return {
        value: finalValue,
        inputProps,
        isOpen,
        disableIncrement,
        handleOnChange,
        handleOnSelectChange,
        basePanel
    };
};
export default usePassengersMobile;

//# sourceMappingURL=usePassengersMobile.js.map